import { Component } from '../Component'
import { inject } from '../../services/di'
import { element } from '../CustomElement'
import { i18n } from '../../i18n/I18n'
import { LocationService } from '../../services/LocationService'
import { Link } from '../flipp-link/Link'
import { CategoryService } from '../../services/CategoryService'

@element('proudly-canadian-banner')
export class ProudlyCanadianBanner extends Component<any, any> {
    @inject location: LocationService
    @inject categoryService: CategoryService

    render() {
        const isFrench = this.location.locale === 'fr-ca'
        const textClassAppendix = isFrench ? ' french' : ''
        return (
            <div class="proudly-canadian-banner">
                <div
                    class={`proudly-canadian-banner__title ${textClassAppendix}`}
                >
                    <p>{i18n('proudly_canadian_banner_title')}</p>
                </div>
                <div
                    class={`proudly-canadian-banner__more ${textClassAppendix}`}
                >
                    {!this.categoryService.isProudlyCanadianCategory()
                        ? this.renderButton()
                        : null}
                </div>
            </div>
        )
    }

    renderButton() {
        const textClassAppendix =
            this.location.locale === 'fr-ca' ? ' french' : ''
        const textClass = 'flipp-button' + textClassAppendix
        return (
            <Link class={textClass} to="proudlyCanadian">
                {i18n('proudly_canadian_deals')}
            </Link>
        )
    }
}
